import { RobotOutlined } from '@ant-design/icons';

interface LaudoTabHeaderProps {
  isAutomaticAiReport: boolean;
}
export function LaudoTabHeader({ isAutomaticAiReport }: LaudoTabHeaderProps) {
  if (isAutomaticAiReport) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <RobotOutlined style={{ fontSize: 20, color: '#1890ff' }} />
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Laudo Automático (IA)</h3>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
      }}
    >
      <div>
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Laudos de Avaliação</h3>
      </div>
    </div>
  );
}
